import { useEffect, useMemo, useRef, useState } from "react";
import { Button, Card, Divider } from "@mui/material";
import { H5 } from "components/Typography";
import { useSearchPage } from "hooks";
import { buildTier, cpuTypes } from "../constants/builds-categories";
import { PriceRangeBuild } from "./PriceRangeBuild";
import { useRouter } from "next/router";

const BuildFilterCard = ({
  onchange,
  onChangePriceRange,
  onHandleClearKeyword,
}) => {
  const { subCategoryClearKeywordState } = useSearchPage();
  const router = useRouter();
  const { cpu, build_tier } = router.query;

  const [selectedCPU, setSelectedCPU] = useState<string | null>(null);
  const [selectedBuildTier, setSelectedBuildTier] = useState<string | null>(
    null
  );

  useEffect(() => {
    setSelectedCPU(typeof cpu === "string" ? cpu : null);
    setSelectedBuildTier(typeof build_tier === "string" ? build_tier : null);
  }, [cpu, build_tier]);

  useEffect(() => {
    if (onHandleClearKeyword) {
      setSelectedCPU(null);
      setSelectedBuildTier(null);
    }
  }, [onHandleClearKeyword]);

  const onClickCategoryItem = (value: string) => {
    subCategoryClearKeywordState("", true);

    if (cpuTypes.some((cpu) => cpu.value === value)) {
      setSelectedCPU((prev) => {
        const newValue = prev === value ? null : value;
        onchange(newValue);
        return newValue;
      });
    } else if (buildTier.some((tier) => tier.value === value)) {
      setSelectedBuildTier((prev) => {
        const newValue = prev === value ? null : value;
        onchange(newValue);
        return newValue;
      });
    }

    onchange(value);
  };

  return (
    <Card
      sx={{
        p: "1rem",
        flexDirection: "column",
        display: "flex",
        alignItems: "flex-start",
        width: "100%",
      }}
      elevation={0}
    >
      <PriceRangeBuild
        onChangePriceRange={onChangePriceRange}
        onHandleClearKeyword={onHandleClearKeyword}
      />
      <H5 mb={1.25}>CPU Types</H5>

      {cpuTypes.map((item) => (
        <Button
          fullWidth
          key={item.value}
          sx={{
            my: 0.3,
            justifyContent: "flex-start",
            p: "0.5rem",
            width: "100%",
          }}
          onClick={() => onClickCategoryItem(item.value)}
          variant={
            selectedCPU === item.value || cpu === item.value
              ? "contained"
              : "text"
          }
          color={
            selectedCPU === item.value || cpu === item.value
              ? "primary"
              : "secondary"
          }
        >
          {item.label}
        </Button>
      ))}

      <Divider
        sx={{
          margin: "1em 0",
          width: "100%",
          borderBottom: "1.5px solid rgba(125, 135, 156, 0.2)",
        }}
      />

      <H5 mb={1.25}>Build Tier</H5>

      {buildTier.map((item) => (
        <Button
          fullWidth
          key={item.value}
          sx={{
            my: 0.3,
            justifyContent: "flex-start",
            p: "0.5rem",
            width: "100%",
          }}
          onClick={() => onClickCategoryItem(item.value)}
          variant={
            selectedBuildTier === item.value || build_tier === item.value
              ? "contained"
              : "text"
          }
          color={
            selectedBuildTier === item.value || build_tier === item.value
              ? "primary"
              : "secondary"
          }
        >
          {item.label}
        </Button>
      ))}

      <Divider
        sx={{
          margin: "1em 0",
          width: "100%",
          borderBottom: "1.5px solid rgba(125, 135, 156, 0.2)",
        }}
      />
    </Card>
  );
};

export default BuildFilterCard;
